<div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
    <div id="liveToast" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true">
        <ng-container *ngIf="!pdfnotexist">
            <div class="toast-header">
                <strong class="me-auto" *ngIf="downloading  &&downloadingData.length === 1 ;else items">Downloading
                    {{downloadingData.length}} item</strong>
                <ng-template #items>
                    <strong class="me-auto" *ngIf="downloading">Downloading {{downloadingData.length}} items</strong>
                </ng-template>

                <strong class="me-auto" *ngIf="!downloading; else next">
                    {{ downloadingData.length }} download{{ downloadingData.length !== 1 ? 's' : '' }} complete
                </strong>
                <ng-template #next>
                    <strong class="me-auto" *ngIf="!downloading && downloadingData.length === 1">
                        {{ downloadingData.length }} download complete
                    </strong>
                </ng-template>

                <!-- <small>{{ timeElapsed }} minutes ago</small> -->
                <span type="button" data-bs-dismiss="toast" aria-label="Close" (click)="resetDownloadData()">
                    <fa-icon aria-hidden="true" [icon]="['fas','close']"></fa-icon>
                </span>
            </div>
            <div class="toast-body pt-0 pb-0">
                <div class="row p-3 sepration-line" *ngFor="let download of downloadingData">
                    <div class="col-10 pl-0">
                        <fa-icon aria-hidden="true" class="file-icon pr-3" [icon]="['fas','file-arrow-down']"></fa-icon>
                        <span>{{download.filename}}</span>
                    </div>
                    <div class="col-2 pl-4">
                        <div class="loader" *ngIf="download.download && download"></div>
                        <div class="download-completeted" *ngIf="!download.download">
                            <span class="circle">
                                <fa-icon aria-hidden="true" class="pl-1" [icon]="['fas','check']"></fa-icon>
                            </span>

                        </div>
                    </div>
                </div>


            </div>
        </ng-container>
        <ng-container *ngIf="pdfnotexist">
            <div class="toast-header">
                <strong class="me-auto">Downloading
                    </strong>
                <span type="button" data-bs-dismiss="toast" aria-label="Close" (click)="resetDownloadData()">
                    <fa-icon aria-hidden="true" [icon]="['fas','close']"></fa-icon>
                </span>
            </div>
            <div class="toast-body pt-0 pb-0" *ngFor="let download of downloadingData">
                <div class="row p-3 sepration-line">
                    <div class="col-10 pl-0">
                        <span>{{download.filename}} not found</span>
                    </div>
                    <div class="col-2 pl-4">
                        <div class="download-completeted">
                                <fa-icon class="iconsClass" aria-hidden="true" [icon]="['fas', 'exclamation-triangle']"></fa-icon>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>